// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39qIN","location":"Header_location__y_tuK"};